import { Show } from "solid-js";
import type { SeatFields } from "~/lib/api";

type Props = {
  value: SeatFields;
  onChange: (next: SeatFields) => void;
  disabled?: boolean;
  submitLabel?: string;
  onSubmit: () => void;
  error?: string | null;
  saving?: boolean;
};

export function SeatFieldsForm(props: Props) {
  const set = (patch: Partial<SeatFields>) => {
    props.onChange({ ...props.value, ...patch });
  };

  return (
    <form
      class="stack"
      style={{ gap: "12px" }}
      onSubmit={(e) => {
        e.preventDefault();
        props.onSubmit();
      }}
    >
      <label>
        First name
        <input
          required
          disabled={props.disabled}
          value={props.value.first_name}
          onInput={(e) => set({ first_name: e.currentTarget.value })}
        />
      </label>
      <label>
        Last name
        <input
          required
          disabled={props.disabled}
          value={props.value.last_name}
          onInput={(e) => set({ last_name: e.currentTarget.value })}
        />
      </label>
      <label>
        Email
        <input
          required
          type="email"
          disabled={props.disabled}
          value={props.value.email}
          onInput={(e) => set({ email: e.currentTarget.value })}
        />
      </label>
      <label>
        Company
        <input
          disabled={props.disabled}
          value={props.value.company ?? ""}
          onInput={(e) => set({ company: e.currentTarget.value })}
        />
      </label>
      <label>
        Job role
        <input
          disabled={props.disabled}
          value={props.value.job_role ?? ""}
          onInput={(e) => set({ job_role: e.currentTarget.value })}
        />
      </label>
      <label>
        Dietary requirements
        <input
          disabled={props.disabled}
          value={props.value.dietary_requirements ?? ""}
          onInput={(e) => set({ dietary_requirements: e.currentTarget.value })}
        />
      </label>
      <label class="checkbox-row">
        <input
          type="checkbox"
          disabled={props.disabled}
          checked={Boolean(props.value.attending_after_party)}
          onChange={(e) => set({ attending_after_party: e.currentTarget.checked })}
        />
        Attending after-party
      </label>
      <label class="checkbox-row">
        <input
          type="checkbox"
          disabled={props.disabled}
          checked={Boolean(props.value.share_contact_with_sponsors)}
          onChange={(e) => set({ share_contact_with_sponsors: e.currentTarget.checked })}
        />
        Share contact details with sponsors
      </label>

      <Show when={props.error}>
        <div class="error-box">{props.error}</div>
      </Show>

      <button type="submit" class="btn" disabled={props.disabled || props.saving}>
        {props.saving ? "Saving…" : (props.submitLabel ?? "Save")}
      </button>
    </form>
  );
}

export function emptySeatFields(): SeatFields {
  return {
    first_name: "",
    last_name: "",
    email: "",
    company: "",
    job_role: "",
    dietary_requirements: "",
    attending_after_party: false,
    share_contact_with_sponsors: false,
  };
}

export function seatFieldsFrom(partial?: Partial<SeatFields> | null): SeatFields {
  const base = emptySeatFields();
  if (!partial) return base;
  return {
    ...base,
    ...partial,
    first_name: partial.first_name ?? "",
    last_name: partial.last_name ?? "",
    email: partial.email ?? "",
  };
}
